/* eslint-disable prettier/prettier */
/*
 * Copyright (C) 2024 Webformat S.r.l.
 * https://www.webformat.com
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import cart from '@/store/modules/cart';
import user from '@/store/modules/user';
import checkout from '@/store/modules/checkout';
import cms from '@/store/modules/cms';
import store from '@/store';
import {mockData, setJWT} from '@/store/api';
import {ShippingInfoData} from '@/store/models';
import {decode as decodeShipment} from '@/commons/shipmentMethodHelpers';
import {bus} from './bus';

const event = 'app.init';

export default event;

function assignDefaultUserNameToAddress() {
    if (user.isLoggedin) {
        if (!user.hasAddresses) {
            checkout.shippingAddress.firstname = user.customer.firstname;
            checkout.shippingAddress.lastname = user.customer.lastname;
            checkout.billingAddress.firstname = user.customer.firstname;
            checkout.billingAddress.lastname = user.customer.lastname;
        }
        if (!checkout.email) {
            checkout.setEmail(user.customer.email);
        }
    }
}

function assignDefaultShippingMethod() {
    if (!user.isLoggedin && !cart.isEmpty && checkout.selectedShipment.toString() === '') {
        if (store.state.options.carrier.default) {
            const defaultMethod = store.state.options.carrier.default;
            const data: ShippingInfoData = {
                address: checkout.defaultShippingAddress,
                shippingmethod: decodeShipment(defaultMethod),
            };
            checkout.setSelectedShipment(defaultMethod);
            checkout.setShippingInfo(data);
        }
    }
}

function getCartInfos(resolve: any, data: any) {
    const promises: any = [cart.getCart(), cart.getTotals()];

    let userEmail = '';

    if (process.env.VUE_APP_FLOW === 'logged' || (process.env.VUE_APP_FLOW === 'loggedsess' && data.user)) {
        userEmail = data.user;
    }

    mockData(userEmail).then(res => {
        store.state.countryData = res.countrydata;
        store.state.options = res.settings;
        // store.state.options = res.generalOptions;
        cms.setAgreements(res.agreements);
        cms.setBlocks(res.cmsblocks);
        if (res.checkoutEmail) {
            checkout.setEmail(res.checkoutEmail);
        }
    });

    Promise.all(promises).then(values => {
        const innerpromises: any = [
            checkout.estimateShipping(checkout.defaultShippingAddress),
            checkout.getCoupon(),
            checkout.getPaymentMethods(
                checkout.billingSameAsShipping ? checkout.shippingAddress : checkout.billingAddress,
                checkout.shippingAddress
            ),
            checkout.getSelectedPayment(),
        ];

        Promise.all(innerpromises).then(values2 => {
            assignDefaultUserNameToAddress();
            assignDefaultShippingMethod();
            resolve([values, values2]);
        });
    });
}

bus.$on(event, (data: any) => {
    if (process.env.NODE_ENV !== 'production') {
        if (data.cart) {
            cart.setToken(data.cart);
            getCartInfos(data.resolveProm, {});
        } else if (data.user) {
            user.login({username: data.user, password: data.pass, cartToken: ''}).then(() => {
                getCartInfos(data.resolveProm, {user: data.user});
                checkout.setEmail(data.user);
            });
        } else if (data.token) {
            setJWT(data.token);
            user.getMe()
                .then(() => {
                    getCartInfos(data.resolveProm, {user: user.customer.email});
                    checkout.setEmail(user.customer.email);
                })
                .catch(e => {
                    // eslint-disable-next-line no-console
                    console.log(e);
                    localStorage.removeItem('usertoken');
                });
        }
    } else {
        if (!checkout.shippingAddress.id && !cart.isEmpty) {
            checkout.assignShippingAddress(checkout.shippingAddress);
        }

        assignDefaultUserNameToAddress();
        assignDefaultShippingMethod();
    }
});
